import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const getSelectedOrderType = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.orderType);
